import { motion } from "framer-motion";
import usePreferStaticUI from "@/lib/usePreferStaticUI";

/**
 * Rising smoke / vapour wisps — soft curls drifting upward.
 */
export const SmokeWisps = ({ count = 4, className = "", subtle = false }) => {
  const reduced = usePreferStaticUI();

  if (reduced) return null;

  const wisps = Array.from({ length: count }, (_, i) => ({
    left: `${8 + i * (84 / Math.max(count - 1, 1))}%`,
    delay: i * 1.4,
    size: 72 + (i % 3) * 28,
    tone: i % 2 === 0
      ? subtle
        ? "from-roseMilk/12 via-lavenderFog/8"
        : "from-roseMilk/25 via-lavenderFog/15"
      : subtle
        ? "from-lavenderFog/10 via-sageMint/6"
        : "from-lavenderFog/22 via-sageMint/12",
    peakOpacity: subtle ? 0.18 : 0.35,
  }));

  return (
    <div className={`absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {wisps.map((w, i) => (
        <motion.div
          key={i}
          className={`absolute bottom-[-15%] rounded-[50%] blur-3xl bg-gradient-to-t ${w.tone} to-transparent pointer-events-none`}
          style={{ left: w.left, width: w.size, height: w.size * 1.6, marginLeft: -w.size / 2 }}
          animate={{
            y: [0, -100, -220],
            x: [0, (i % 2 === 0 ? 12 : -12), 0],
            opacity: [0, w.peakOpacity, 0],
            scale: [0.7, 1.15, 1.35],
          }}
          transition={{
            duration: 9 + i * 0.8,
            repeat: Infinity,
            delay: w.delay,
            ease: "easeOut",
          }}
        />
      ))}
    </div>
  );
};

export default SmokeWisps;
